import { createContext } from "react";
import { type ISettingContextTypes } from "@/api/settings/types";

export const SettingsContext = createContext<ISettingContextTypes | null>(null);
